import gql from 'graphql-tag'

const productsGetQuery = gql`
  query productsGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object, $nested: boolean, $nestedFields: [String]) {
    productsGet(
      input: {
        limit: $limit
        offset: $offset
        criteria: $criteria
        sort: $sorting
        select: $select
        nested: $nested
        nestedFields: $nestedFields
      }
    ) @rest(type: "ProductsResult", method: "POST", path: "product/list") {
      results
      paging
    }
  }
`

export default productsGetQuery
